module.exports = __webpack_public_path__ + "img/features-tabs-icon-03.5b966f3d.svg";